module.exports = __webpack_public_path__ + "static/media/SupplyRoom-b.e5e5d598.webp";